import { createAsyncAction } from 'typesafe-actions';
import { AxiosError } from 'axios';
import { ErrorResponse, SuccessResponse } from '../../types/Response';
import { PotalCommDto } from '../../types/PotalCommDto';
import { OgnzDto, SelectOgnzDto } from '../../types/OgnzDto';

export const FIND_OGNZ_LIST = 'api/FIND_OGNZ_LIST';
export const FIND_OGNZ_LIST_SUCCESS = 'api/FIND_OGNZ_LIST_SUCCESS';
export const FIND_OGNZ_LIST_ERROR = 'api/FIND_OGNZ_LIST_ERROR';

export const findOgnzListAsync = createAsyncAction(
  FIND_OGNZ_LIST,
  FIND_OGNZ_LIST_SUCCESS,
  FIND_OGNZ_LIST_ERROR
)<SelectOgnzDto, SuccessResponse<OgnzDto[], PotalCommDto> | ErrorResponse, AxiosError>();